module.exports = __webpack_public_path__ + "img/candy.1a595273.png";